import axios from 'axios';
const apiBaseUrl = process.env.NODE_ENV === 'development'
  ? (process.env.REACT_APP_API_URL_LOCAL || 'http://localhost:8080')
  : (process.env.REACT_APP_API_URL || 'https://server.azishafiei.com');
const api = axios.create({
  baseURL: apiBaseUrl,
  timeout: 30000,
});
console.info('[AZI Admin API] baseURL:', api.defaults.baseURL);
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('admin_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  console.info('[AZI Admin API] request', { method: config.method, url: `${config.baseURL || ''}${config.url}`, hasAdminToken: Boolean(token) });
  return config;
});
api.interceptors.response.use(
  (response) => {
    console.info('[AZI Admin API] response', { status: response.status, url: response.config?.url });
    return response;
  },
  (error) => {
    console.error('[AZI Admin API] error', {
      baseURL: error.config?.baseURL,
      url: error.config?.url,
      status: error.response?.status,
      response: error.response?.data,
      message: error.message,
      hasAdminToken: Boolean(localStorage.getItem('admin_token')),
    });
    if (
      error.response?.status === 401 &&
      !error.config?.url?.includes('/api/admin/login')
    ) {
      localStorage.removeItem('admin_token');
      localStorage.removeItem('admin_user');
      if (
        !['/login', '/forgot-password', '/reset-password'].includes(
          window.location.pathname,
        )
      )
        window.location.assign('/login');
    }
    return Promise.reject(error);
  },
);
export default api;
